export default __webpack_public_path__ + "static/media/banner-2.53cc1e51.jpg";